<template>
  <div class="row font75">
    <div class="col-sm-12">
      <div>
        <Alerts />
        <div v-if="!user.shipper_id">
          <b-card title="Pitney Bowes">
            <b-card-body>
              <p>
                GrandShipper uses Pitney Bowes to price and provision shipments.
                Please
                <a :href="signupUrl" target="_blank">sign up for a Pitney Bowes account</a>
                then enter your credentials below:
              </p>

              <b-form-row>
                <b-col>
                  <b-form-group label="Pitney Bowes Username:" label-for="connect-username" description>
                    <b-form-input id="connect-username" type="text" v-model="connectForm.username" required
                      placeholder="Enter your Pitney Bowes username"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group label="Pitney Bowes Password:" label-for="connect-password" description>
                    <b-form-input id="connect-password" type="password" v-model="connectForm.password" required
                      placeholder></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </b-card-body>

            <b-card-footer>
              <div class="text-center">
                <b-btn class="btn-blue" @click="onClickConnectPitneyBowes" size="lg">Connect Pitney Bowes
                  Account</b-btn>
              </div>
            </b-card-footer>
          </b-card>
        </div>
        <span v-else>
          <b-alert Alert-alert variant="warning" :show="!user.subscribed">
            <i class="glyphicon glyphicon-exclamation-sign text-danger"></i>
            Looks like you're not subscribe yet. To enjoy these ENTERPRISE features please <a
              href="#/my-account/subscription">subscribe</a>.
          </b-alert>
          <b-tabs>
            <b-tab title="Admin + Sub-Users">
              <p class="font-weight-bold mb-1">Admin Security Settings + Sub-User Creation</p>
              <p>
                This section allows you to create sub-users within your account. &nbsp;As the admin, your sub-user will
                have no access to the Enterprise Features page and limited to no access to the tabs under settings <i
                  class="fa fa-cog" style="font-size: 15px" aria-hidden="true"></i> —> My Account.
              </p>

              <p class="font-weight-bold mb-1">Admin Security Settings</p>

              <p>If box is selected, the Sub-Users will NOT have access to tabs located in the My Account page:</p>

              <b-row class="font-weight-bold">
                <b-col sm="1" class="text-center">Hidden</b-col>
                <b-col sm="auto">Tab Name</b-col>
              </b-row>
              <b-row v-for="t in securityTabOptions" :key="t.value">
                <b-col sm="1" class="text-center">
                  <b-form-checkbox :checked="security.tabs.includes(t.value)" :value="true" :unchecked-value="false"
                    @change="changeSecurityTabs($event, t.value)"></b-form-checkbox>
                </b-col>
                <b-col sm="auto">{{ t.text }}</b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col sm="auto" v-if="user.subscribed">
                  <b-btn class="btn-blue mr-2" @click="saveSecurityTabs">Save Changes</b-btn>
                  <b-btn class="btn-light-blue-outline" @click="security.tabs = []">Reset</b-btn>
                </b-col>
                <b-col sm="auto" v-else>
                  <b-btn class="btn-blue mr-2" @click="promptToSubscribe">Save Changes</b-btn>
                  <b-btn class="btn-light-blue-outline" @click="promptToSubscribe">Reset</b-btn>
                </b-col>
              </b-row>

              <!-- <b-form-group label="Select which settings tabs should be locked down:">
                <b-checkbox-group
                  v-model="security.tabs"
                  :options="securityTabOptions"
                  style="columns: 3"
                  stacked
                  multiple
                ></b-checkbox-group>
              </b-form-group> -->

              <hr />
              <p class="font-weight-bold">Sub-User Creation</p>

              <b-row class="mb-2">
                <b-col>
                  <span>Sub-User Name</span>
                  <i class="ml-2 fa fa-exclamation-circle" style="font-size: 14px" v-b-tooltip.hover.html="name_help"></i>
                  <!-- <span class="text-blue glyphicon glyphicon-exclamation-sign" aria-hidden="true" v-b-tooltip.hover.html="name_help"></span> -->
                </b-col>
                <b-col>
                  <span>Login Credential</span>
                  <i class="ml-2 fa fa-exclamation-circle" style="font-size: 14px"
                    v-b-tooltip.hover.html="username_help"></i>
                  <!-- <span class="text-blue glyphicon glyphicon-exclamation-sign" aria-hidden="true" v-b-tooltip.hover.html="username_help"></span> -->
                </b-col>
                <b-col>
                  <span>Password</span>
                  <i class="ml-2 fa fa-exclamation-circle" style="font-size: 14px"
                    v-b-tooltip.hover.html="password_help"></i>
                  <!-- <span class="text-blue glyphicon glyphicon-exclamation-sign" aria-hidden="true" v-b-tooltip.hover.html="password_help"></span> -->
                </b-col>
                <b-col sm='3'>
                  <span>Assigned Origin Address</span>
                  <!-- <i class="ml-2 fa fa-exclamation-circle" style="font-size: 14px" v-b-tooltip.hover.html="origin_help"></i> -->
                </b-col>
                <b-col sm='2'></b-col>
              </b-row>

              <b-row v-for="(employee, i) in security.employees" :key="i" class="mb-3">
                <b-col>
                  <b-form-input size="sm" v-model="employee.name" :class="[{ 'is-invalid': !employee.name }]"
                    placeholder="Example: John Doe" @input="onTouch"></b-form-input>
                </b-col>
                <b-col>
                  <b-input-group class="default" size="sm" :append="'@gs' + user.id + '.com'">
                    <b-form-input size="sm" v-model="employee.username"
                      :class="[{ 'is-invalid': checkUserName(employee.username) }]" placeholder="Example: John"
                      @input="onTouch"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col>
                  <b-form-input size="sm" v-model="employee.password"
                    :class="[{ 'is-invalid': checkPassword(employee.password) }]" placeholder="Example: John@123!"
                    @input="onTouch"></b-form-input>
                </b-col>
                <b-col sm='3'>
                  <b-form-group>
                    <b-form-select v-model="employee.selectedOrigin" size="sm" :ref="`originDropDown${employee.id}`"
                      :class="['custom-dropdown']" :disabled="!shipper_addresses.length" :options="shipper_addresses"
                      @change="val => {
                        changeEmployeeOrigin(val, employee)
                      }">
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm='2' class="align-self-center">
                  <!-- <b-button variant="success" size="sm" @click.prevent="saveUser(employee.username, employee.id)">Save</b-button> -->
                  <b-btn v-if="user.subscribed" class="btn-red no-hover" size="sm"
                    :disabled="Object.keys(employee).length === 0" @click.prevent="deleteUser(employee.id)">Delete</b-btn>
                  <b-btn v-else class="btn-red no-hover" size="sm" :disabled="Object.keys(employee).length === 0"
                    @click.prevent="promptToSubscribe">Delete</b-btn>
                </b-col>
              </b-row>

              <b-btn v-if="user.subscribed" type="submit" size="sm" class="btn-blue mr-2" @click.prevent="addNewUser">Add
                New Sub-User</b-btn>
              <b-btn v-else class="btn-blue mr-2" size="sm" @click="promptToSubscribe">Add New Sub-User</b-btn>
              <!-- class="btn-light-blue-outline" -->

              <b-btn v-if="user.subscribed" :disabled="isEmployeesInvalid || !isSubUserDirty" type="submit"
                class="btn-blue mr-2" size="sm" @click.prevent="updateSecurity">Save Changes</b-btn>
              <b-btn v-else class="btn-blue mr-2" size="sm" @click="promptToSubscribe">Save Changes</b-btn>
            </b-tab>

            <b-tab title="Email Notification">
              <p class="font-weight-bold">Tracking Email Notification Template</p>
              <p>
                If the button is selected as Active with a valid email address entered. &nbsp;Once the label is printed,
                the system will generate and send the template. &nbsp;There could be a few minutes delay upon the
                recipient receiving the email. &nbsp;The email sent cannot be retracted.
              </p>
              <b-row>
                <b-col>
                  <toggle-button :color="{ checked: '#36b520', unchecked: '#f29fa1' }"
                    :switch-color="{ checked: '#0c820a', unchecked: '#820a0c' }"
                    :value="user.emailNotif === 1 ? true : false" :width="65" @change="emailToggle"
                    :labels="{ checked: 'Active', unchecked: 'Inactive' }" />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <b-form-group>
                    <b-form-select type="text" size="sm" v-model="selectedEmailTemplate" :options="emailTemplateOptions"
                      placeholder="Select a default template" @change="showTheTemplate" class="mt-2"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col style="margin-top: 10px;">
                  <b-form-group>
                    <b-form-checkbox v-model="defaultTemplate" @change="setDefaultTemplate" class="checkLabel">
                      Set as default
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form @submit.prevent="saveEmailTemplate">
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <b-form-input type="text" size="sm" v-model="emailTemplate.name" placeholder="Enter template name"
                        :class="['mt-2', { 'is-invalid': !emailTemplate.name }]"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <b-form-input type="text" size="sm" v-model="emailTemplate.bcc"
                        placeholder="BCC: email address (Optional)" class="mt-2"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group>
                      <b-form-input type="text" size="sm" v-model="emailTemplate.subject"
                        placeholder="Enter subject line: (For example: You've got a package headed your way from Grandshipper.com!)"
                        :class="['mt-2', { 'is-invalid': !emailTemplate.subject }]"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                </b-row>

                <p>Below are data fields that you can add/remove within the body of the email.</p>
                <b-row class="mt-2">
                  <b-col>
                    <b-form-group>
                      <template v-slot:label>
                        <span class="h6">
                          <b-btn v-for="v in emailParams" size="sm" class="btn-blue mb-2 mr-1 py-0 px-1"
                            @click="setParam(v)" :key="v">
                            {{ v }}
                          </b-btn>
                        </span>
                      </template>
                      <b-form-textarea ref="emailBody" size="sm" class="mt-2" rows=12 v-model="emailTemplate.body">
                      </b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- buttons -->
                <b-row class="mt-3" v-if="user.subscribed">
                  <b-col>
                    <b-btn type="submit" class="btn-light-blue-outline mr-2" size="sm">Save Template</b-btn>
                    <b-btn class="btn-light-blue-outline mr-2" size="sm" @click="clearEmailTemplateFields">Create a New
                      Template</b-btn>
                    <b-btn class="btn-blue" size="sm" v-b-modal.test-email-modal>Send a Test Email</b-btn>
                  </b-col>
                </b-row>
                <b-row class="mt-3" v-else>
                  <b-col>
                    <b-btn class="btn-light-blue-outline mr-2" size="sm" @click="promptToSubscribe">Save
                      Template</b-btn>
                    <b-btn class="btn-light-blue-outline mr-2" size="sm" @click="promptToSubscribe">Create a New
                      Template</b-btn>
                    <b-btn class="btn-blue" size="sm" @click="promptToSubscribe">Send a Test Email</b-btn>
                  </b-col>
                </b-row>
              </b-form>

              <!-- test email modal -->
              <b-modal id="test-email-modal" ref="modal" title="Send Test Email" @ok="okTestEmail">
                <form ref="emailTest" @submit.stop.prevent="sendTestEmail">
                  <b-form-group label="Please enter a valid email address to send preview template."
                    label-for="email-input" invalid-feedback="Email is required" :state="emailState">
                    <b-form-input id="email-input" v-model="testEmail" required></b-form-input>
                  </b-form-group>
                </form>
              </b-modal>
            </b-tab>

            <b-tab @click="fetchProducts()" :active="!!showProductTab">
              <template slot="title">
                Product & SKU Manager
                <!-- <img src="/images/new.png" style="width: 20px; margin: -20px 0 0 -5px;" /> -->
              </template>
              <div class="product">
                <p>
                  Save time and manual entry errors by utilizing this feature. &nbsp;It allows you to upload or manually
                  enter a product while prefilling all the Package Detail fields. &nbsp;By using our Search function, it
                  allows you to quickly find the product and print a label.
                </p>
                <b-modal ref="productModal" size="lg" centered laze no-close-on-esc hide-header-close no-close-on-backdrop
                  :visible="showProductModal" no-fade>
                  <template slot="modal-header">
                    <div class="modal-title font100">
                      <span v-if="isProductEdit">Edit Product</span>
                      <span v-else>Add Product</span>
                    </div>
                    <button @click="onHideProductModal(false)" type="button" aria-label="Close" class="close">×</button>
                  </template>
                  <template slot="modal-footer">
                    <b-btn class="btn-blue" size="sm" @click="onHideProductModal(true)" :disabled="isProductInvalid">
                      <span v-if="isProductEdit">Save Product</span>
                      <span v-else>Add Product</span>
                    </b-btn>
                    <!-- <b-btn
                      variant="secondary"
                      size="sm"
                      style="background-color: #858888; border: 1px solid #858888;"
                      @click="onHideProductModal(false)"
                    >Close</b-btn> -->
                  </template>

                  <b-form-row>
                    <b-col>
                      <b-form-group>
                        <b-form-input size="sm" :class="[{ 'is-invalid': !product.product_name }]"
                          v-model="product.product_name" type="text" placeholder="Product (searchable)"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col>
                      <b-form-group>
                        <b-form-input size="sm" v-model="product.sku" type="text" placeholder="SKU (searchable)"
                          maxlength="15"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col>
                      <b-form-group>
                        <!-- <b-form-input
                          size="sm"
                          :class="[{'is-invalid': !product.service_class}]"
                          v-model="product.service_class"
                          type="text"
                          placeholder="Service Class"
                        ></b-form-input> -->

                        <b-select size="sm" :options="serviceOptions" v-model="product.service_class"
                          :class="['form-control', 'custom-dropdown', { 'is-invalid': !product.service_class }]"
                          @change="onServiceClassChange">
                          <template slot="first">
                            <option :value="''" disabled>Select Service Class</option>
                          </template>
                        </b-select>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col>
                      <b-form-group>
                        <!-- <b-form-input
                          size="sm"
                          :class="[{'is-invalid': !product.package_type}]"
                          v-model="product.package_type"
                          type="text"
                          placeholder="Package Type"
                        ></b-form-input> -->

                        <b-select size="sm" :options="packageOptions"
                          :class="['form-control', 'custom-dropdown', { 'is-invalid': !product.package_type && product.service_class }]"
                          :disabled="!product.service_class" v-model="product.package_type" @change="onPackageChange">
                          <template slot="first">
                            <option :value="''" disabled>Select Package Type</option>
                          </template>
                        </b-select>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col sm="6">
                      <b-form-group>
                        <b-form-input size="sm" :class="[{ 'is-invalid': noWeight && !noLB }]" v-model="product.weight.lb"
                          :disabled="noLB" type="number" placeholder="Weight (lb.)"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <b-form-input size="sm" :class="[{ 'is-invalid': noWeight }]" v-model="product.weight.oz"
                          type="number" placeholder="Weight (oz.)"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col sm="4">
                      <b-form-group>
                        <b-form-input size="sm" :disabled="isDimAllowed" :class="[{ 'is-invalid': !checkDimensions }]"
                          v-model="product.package_length" type="number" placeholder="Package Length"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group>
                        <b-form-input size="sm" :disabled="isDimAllowed" :class="[{ 'is-invalid': !checkDimensions }]"
                          v-model="product.package_width" type="number" placeholder="Package Width"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group>
                        <b-form-input size="sm" :disabled="isDimAllowed || product.package_type == 'SOFTPACK'"
                          :class="[{ 'is-invalid': !checkDimensions }]" v-model="product.package_height" type="number"
                          placeholder="Package Height"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                  <!-- <b-form-row>
                    <b-col>
                      <b-form-group>
                        <b-form-input
                          size="sm"
                          v-model="product.packaging_weight"
                          type="number"
                          placeholder="Packageing Weight"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row> -->
                  <b-form-row>
                    <b-col>
                      <b-form-group>
                        <b-form-input size="sm" v-model="product.declared_value" type="number"
                          placeholder="Declared value"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                </b-modal>

                <div>
                  <LoadingSpinner v-if="isLoading" />
                  <b-form-group class="form-inline pull-left mb-2">
                    <b-btn v-if="user.subscribed" size="sm" href="/guides/GS_Product_Guide.zip" class="vgt-left-btn">
                      <span class="glyphicon glyphicon-download-alt"></span>
                      Reference Guide
                    </b-btn>
                    <b-btn v-else size="sm" class="vgt-left-btn" @click="promptToSubscribe">
                      <span class="glyphicon glyphicon-download-alt"></span>
                      Reference Guide
                    </b-btn>

                    &nbsp;
                    <!-- <b-btn class="vgt-left-btn" size="sm" href="/#/orders/upload-import">
                      Upload File
                      <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-paperclip" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
                      </svg>
                    </b-btn> &nbsp; -->
                    <import-products-button :subscribed="user.subscribed" @imported="imported"></import-products-button>
                    &nbsp;
                    <b-btn :disabled="!user.subscribed" href class="vgt-left-btn" size="sm"
                      @click="onShowProductModal">New Product</b-btn>&nbsp;
                    <b-btn href class="vgt-left-btn vgt-red" size="sm"
                      :disabled="serverParams.ids.length < 1 || !user.subscribed"
                      @click="deleteProducts">Delete</b-btn>&nbsp;
                  </b-form-group>

                  <b-form-group class="form-inline pull-right mb-2">
                    <b-input-group>
                      <b-input class="table-search border-right-0 border" v-model="searchTerm" size="sm"
                        placeholder="Search" />
                      <b-input-group-append>
                        <b-button variant="outline-error" class="border-left-0 border" @click="(e) => {
                          if (searchTerm) {
                            searchTerm = '';
                          }
                        }">
                          <i :class="['fa', 'fa-times', { 'opacity-0': !searchTerm }]"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    &nbsp;
                    <!-- <b-dropdown id="dropdown-1" text="Edit Columns" size="sm" class="vgt-right-btn">
                      <b-dropdown-form style="padding-left: 0.5rem">
                        <b-form-checkbox-group v-model="selectedColumns">
                          <b-form-checkbox v-for="col in columnSelection" :key="col.field" :value="col.field">
                            {{ col.label }}
                          </b-form-checkbox>
                        </b-form-checkbox-group>
                        <b-dropdown-item-button @click="onVGTColumnSelect">
                          <b-button size="sm" class="vgt-right-bnt" block>Apply</b-button>
                        </b-dropdown-item-button>
                      </b-dropdown-form>
                    </b-dropdown> -->
                  </b-form-group>
                </div>

                <div class="clearfix"></div>

                <b-row class="justify-content-end">
                  <b-col sm="auto" style="z-index: 999;">
                    <b-input-group class="mb-2">
                      <div class="db-help import">
                        <b-dropdown variant="link" toggle-class="text-decoration-none" dropup no-caret>
                          <template slot="button-content">
                            <b-img src="/images/icons/information.png" />
                          </template>
                          <b-dropdown-text class="mb-0 py-1 px-2" style="width: 304px">
                            <ul>
                              <li>Maximum selected records is {{ serverParams.perPage }}</li>
                              <li>Records selected has to be within the current table</li>
                            </ul>
                          </b-dropdown-text>
                        </b-dropdown>
                      </div>
                      <b-form-input class="table-search border-right-0 border" size="sm" v-model="customRange"
                        placeholder="Custom Range (e.g. 1-5, 10)" style="width: 200px;"
                        @keyup.enter="customSelectedRows" />
                      <b-input-group-append>
                        <b-button variant="outline-error" class="border-left-0 border" @click="(e) => {
                          if (customRange) {
                            customRange = '';
                          }
                        }">
                          <i :class="['fa', 'fa-times', { 'opacity-0': !customRange }]"></i>
                        </b-button>
                      </b-input-group-append>
                      <b-input-group-append>
                        <b-btn variant="success" @click="customSelectedRows">Go</b-btn>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>

                <vue-good-table ref="vgt" mode="remote" :columns="columns" :rows="rows"
                  styleClass="vgt-table striped bordered condensed" max-height="70vh"
                  :select-options="{ enabled: true, selectOnCheckboxOnly: true, selectionText: selected_text, clearSelectionText: 'Unselect All', selectionInfoClass: selection_class }"
                  :search-options="{ enabled: true, externalQuery: searchTerm }"
                  :pagination-options="{ enabled: true, mode: 'records', rowsPerPageLabel: 'Records per page', perPage: serverParams.perPage, perPageDropdown: [50, 100, 250], dropdownAllowAll: false }"
                  :totalRows="totalRecords" :line-numbers="true" @on-search="onVGTSearch"
                  @on-selected-rows-change="onVGTSelected" @on-page-change="onVGTPageChange"
                  @on-sort-change="onVGTSortChange" @on-column-filter="onVGTColumnFilter"
                  @on-per-page-change="onVGTPerPageChange">
                  <div slot="emptystate"> N/A </div>
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field === 'id'">
                      <button :class="['btn', 'btn-xs', 'view', 'btn-warning']"
                        @click="showProduct(props.row.id)">Edit</button>
                    </span>
                    <span v-else-if="props.column.field === 'weight_lb'">
                      {{ getWeight(props.row.weight).lb }}lb
                    </span>
                    <span v-else-if="props.column.field === 'weight_oz'">
                      {{ getWeight(props.row.weight).oz }}oz
                    </span>
                    <span v-else-if="['package_length', 'package_width', 'package_height'].includes(props.column.field)">
                      <span v-if="props.row[props.column.field] != '0.00'">{{ props.row[props.column.field] }}</span>
                    </span>
                    <span v-else-if="['declared_value'].includes(props.column.field)">
                      {{ format.price(props.row[props.column.field]) }}
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </b-tab>
            <!-- <b-tab :active="!!showGuaranteedClaim">
              <template slot="title">
                <span class="position-relative">
                  Guaranteed Claims Auditor
                </span>
              </template>
              <p class="font-weight-bold">Pitney Bowes 3-Day<span class="font-weight-bold text-danger" style="background-color: #fdff3a;">*</span> Delivery with a Money Back Guarantee</p>
              <p>
                We understand that shipping is a constant challenge where meeting delivery standards is important.&nbsp;&nbsp;
                As a valued partner of Pitney Bowes, we supports their exclusive 3-day<span class="font-weight-bold text-danger" style="background-color: #fdff3a;">*</span> Delivery Guarantee for First-Class Package and Priority Mail.&nbsp;&nbsp;
                The Guaranteed Claims page tracks your package from the time it was accepted scan by the USPS to the time it is delivered.&nbsp;&nbsp;
                If your package exceeds the 3-day<span class="font-weight-bold text-danger" style="background-color: #fdff3a;">*</span> delivery timeframe, you can file a claim with Pitney Bowes for your shipping cost (yes, even if it was delivered).
              </p>
              <p>
                <strong>Disclaimer</strong> – this is a Pitney Bowes offer where claims submitted are approved within their discretion and guidelines.&nbsp;&nbsp;
                For more info in the claims process - <a target="_blank" href="https://www.pitneybowes.com/us/shipping-and-mailing/ecommerce/delivery-services/delivery-guarantee/3-day-guaranteed-delivery.html">click here</a>.&nbsp;&nbsp;
                Pitney Bowes Full Terms and Conditions - <a target="_blank" href="https://www.pitneybowes.com/content/dam/pitneybowes/us/en/developer/shipping_api_merchant_terms_and_conditions_final_2019.02.01_v2.pdf">click here</a>.&nbsp;&nbsp;
                Please email all questions to <a target="_blank" href="mailto:PBDClaims@pb.com">PBDClaims@pb.com</a>.
              </p>
              <toggle-button
                :color="{checked: '#36b520', unchecked: '#f29fa1'}"
                :switch-color="{checked: '#0c820a', unchecked: '#820a0c'}"
                :value="user.enable_guaranteed_claim === 1? true : false"
                :width="65"
                @change="guarnateedClaimToggle"
                :labels="{checked: 'Active', unchecked: 'Inactive'}"
                :disabled="true"
              />
              <span class="ml-2">
                If active, the Guaranteed Claims menu page will be enabled.
              </span>

              <hr />

              <div class="ship-audit-faq mt-3">
                <p class="font-weight-bold">Pitney Bowes Delivery Guarantee Service Claims Frequently Asked Questions.</p>
                  <p class="mb-1">What shipments qualify?</p>
                  <ul>
                    <li>
                      Qualifying shipments include expedited mail classes, including but not limited to USPS expedited classes (for example, Priority Mail, Priority Mail Express, and First Class Package), and expedited classes as defined by other domestic carriers subcontracted by Pitney Bowes for this product.&nbsp;&nbsp;
                      Please see the Delivery Guarantee section of our Terms and Conditions for full eligibility rules.&nbsp;&nbsp;
                      Qualifying shipments may change from time to time, and you will be notified of any such change.
                    </li>
                  </ul>
                  <p class="mb-1">Which States qualify for a claim?</p>
                  <ul>
                    <li>Lower 48 Contiguous States</li>
                  </ul>
                  <p class="mb-1">Which States and Territories <strong><u>do not</u></strong> qualify?</p>
                  <ul>
                    <li>Hawaii (HI), Alaska (AL), Puerto Rico (PR), American Samoa (AS), Guam (GU), Northern Mariana Islands (MP), U.S. Virgin Islands (VI)</li>
                    <li>Military Bases such as APO, FPO, DPO, etc.</li>
                  </ul>
                  <p class="mb-1">How will I receive my money back?</p>
                  <ul>
                    <li>
                      Refunds are credited to your Pitney Bowes Postage Account.
                    </li>
                  </ul>
                  <p class="mb-1">How is 3-day<span class="font-weight-bold text-danger" style="background-color: #fdff3a;">*</span> delivery time calculated?</p>
                  <ul>
                    <li><strong>Pitney Bowes added an additional business day</strong> to the anticipated delivery timeframe for delivery guarantee service due to COVID-19 related limitations starting April 22, 2020.&nbsp;&nbsp;Which means that the 3-day is <span class="font-weight-bold text-danger" style="background-color: #fdff3a;">extended to 4-day until further notice</span>.</li>
                    <li>Delivery time is calculated from the time a parcel is accepted to the time it is delivered or delivery was first attempted.</li>
                    <li>
                      <strong>Weekends and federal holidays are excluded</strong> from the delivery time calculation.&nbsp;&nbsp;
                      Some exclusions apply.&nbsp;&nbsp;
                      Details are available in our terms and conditions.
                    </li>
                    <li>Example - If a parcel is accepted on Monday and delivered on Thursday, then delivery time is 3 days.</li>
                  </ul>
                  <p class="mb-1">How do I file a claim?</p>
                  <ul>
                    <li>
                      Simply complete and return a <a target="_blank" href="https://www.pitneybowes.com/content/dam/pitneybowes/us/en/developer/delivery_guarantee_claims_form.pdf">claim form</a> to <a href="mailto:PBDClaims@pb.com">PBDClaims@pb.com</a>.
                    </li>
                  </ul>
                  <p class="mb-1">How long does it take to receive my refund?</p>
                  <ul>
                    <li>
                      Refunds are processed within 60 days of receipt.
                    </li>
                  </ul>
                  <p class="mb-1">How long do I have to submit a claim?</p>
                  <ul>
                    <li>
                      14 days from when a Delivery Guarantee parcel is scanned and a carrier has taken possession of the parcel.
                    </li>
                  </ul>
                  <p class="mb-1">Are there any exceptions?</p>
                  <ul>
                    <li>
                      Some exceptions do apply.&nbsp;&nbsp;
                      Delays related to circumstances outside our control, such as inclement weather, origins or destinations outside the contiguous United States, and shipments that do not comply with service restrictions and conditions are not eligible.&nbsp;&nbsp;
                      Details are available in our terms and conditions.
                    </li>
                  </ul>
                  <p class="mb-1">What happens after I file a claim?</p>
                  <ul>
                    <li>
                      You’ll receive an acknowledgement of receipt of your claim within 24 hours.&nbsp;&nbsp;
                      Then, we’ll investigate your claim, provide a written notice of determination, and refund approved claims to the shipper’s Pitney Bowes Postage account within 60 days.
                    </li>
                  </ul>
                  <p class="mb-1">How can I check the status of my claim?</p>
                  <ul>
                    <li>
                      Approved claims are reflected on your account as a credit to the original tracking number of delayed shipment.&nbsp;&nbsp;
                      Alternatively, you can contact us at <a href="mailto:PBDClaims@pb.com">PBDClaims@pb.com</a> with any claim related questions.
                    </li>
                  </ul>
              </div>
            </b-tab> -->
          </b-tabs>
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ship-audit-faq {

  // h6 {
  //   margin: 0;
  // }
  ul {
    margin-bottom: 0.5rem;
  }
}

#disable-btn {
  &:hover {
    background-color: #53b13e !important;
    border-color: #53b13e !important;
  }
}

#delete-btn {
  &:hover {
    background-color: #dc3545;
    border-color: #dc3545;
  }
}

.subscribe-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.blurred {
  pointer-events: none;
  filter: blur(8px);
  -webkit-filter: blur(8px);
}

.blur-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss">
.checkLabel label {
  padding-top: 3px;
}
</style>

<script>
import { withSpace, isPasswordSecure } from "../mixins/checker";
import LoadingSpinner from "../components/LoadingSpinner";
import Alerts from "../components/Alerts";
import Security from '../mixins/Security'
import { mapGetters, mapActions } from "vuex";
import { ToggleButton } from 'vue-js-toggle-button'
import { VueGoodTable } from 'vue-good-table';
import ImportProductsButton from "../components/ImportProductsButton";

export default {
  components: {
    LoadingSpinner,
    Alerts,
    ToggleButton,
    VueGoodTable,
    ImportProductsButton
  },
  mixins: [
    Security
  ],
  data() {
    return {
      isSubUserDirty: false,
      customRange: '',
      selected_text: 'Records Selected',
      selection_class: 'vgtSelectInfo',
      signupUrl: null,
      connectForm: {},
      showProductTab: null,
      // showGuaranteedClaim: null,
      testEmail: '',
      emailState: null,
      emailParams: [
        "TRACKING_NUMBER_LINK",
        "RECIPIENT_FULL_NAME",
        "RECIPIENT_COMPANY",
        "RECIPIENT_ADDRESS",
        "SENDER_FULL_NAME",
        "SHIPMENT_DATE",
        "ESTIMATED_DELIVERY_DATE",
        "SHIPMENT_ORDER_NUMBER",
        "MARKETPLACE",
        "SERVICE_CLASS",
        "CUSTOM_FIELD_1",
      ],
      emailTemplateOptions: [],
      emailTemplates: [],
      selectedEmailTemplate: null,
      defaultTemplate: false,
      emailTemplate: {
        name: '',
        fromEmail: '',
        fromName: '',
        subject: '',
        body: `
Hello [[RECIPIENT_FULL_NAME]],

You've got a USPS package heading your way!

Shipped on: [[SHIPMENT_DATE]]

Estimated Delivery Date: [[ESTIMATED_DELIVERY_DATE]]

Recipient Address: [[RECIPIENT_ADDRESS]]

Service Class: [[SERVICE_CLASS]]

Shipped via USPS: [[TRACKING_NUMBER_LINK]]

Please allow up to 24 hours for tracking events to update.

Regards,

[[SENDER_FULL_NAME]]`.trim(),
      },
      security: {
        new_name: null,
        new_username: null,
        new_password: null,
        employees: [{}],
        tabs: [],
        features: [],
      },
      securityTabOptions: [
        { text: 'Account Information', value: 'account-info' },
        { text: 'Subscription', value: 'subscription' },
        { text: 'Origin Addresses', value: 'origins' },
        { text: 'Label Settings & Hardware', value: 'print-settings' },
        { text: 'Integrations', value: 'integrations' },
        { text: 'Postage Settings', value: 'postage' },
        { text: 'Shipment Settings', value: 'advanced' },
        { text: 'Shipsurance', value: 'shipsurance' },
      ],
      name_help: {
        title: '<ul class="pl-3 mb-0 text-left"><li>Name of the Sub-User</li></ul>',
        html: true
      },
      username_help: {
        title: '<ul class="pl-3 mb-0 text-left"> \
                  <li>4 Minimum Characters</li> \
                  <li>No Spaces</li> \
                  <li>No special characters allowed</li> \
                  <li>Hint: You must include the @gsXXX.com as the login username. i.e. John@gsXXX.com</li> \
                </ul>',
        html: true
      },
      password_help: {
        title: '<ul class="pl-3 mb-0 text-left"> \
                  <li>8 Minimum Characters</li> \
                  <li>1 Capital Letter</li> \
                  <li>1 Lower Case Letter</li> \
                  <li>1 Special Character</li> \
                  <li>1 Number</li> \
                  <li>No Spaces</li> \
                </ul>',
        html: true
      },
      origin_help: {
        title: '<ul class="pl-3 mb-0 text-left"> \
                  <li>default</li> \
                </ul>',
        html: true
      },
      shipper_addresses: [],
      selectedOrigin: null,

      isLoading: false,
      isProductEdit: false,
      showProductModal: false,
      product: {
        id: '',
        product_name: '',
        sku: '',
        service_class: '',
        package_type: '',
        package_length: '',
        package_width: '',
        package_height: '',
        // packaging_weight: '',
        declared_value: '',
        total_weight: 0,
        weight: {
          lb: '',
          oz: ''
        }
      },
      selected: [],

      searchTerm: '',
      rows: [],
      totalRecords: 0,
      serverParams: {
        columns: null,
        searchTerm: '',
        ids: [],
        sort: null,
        page: null,
        perPage: 50,
      },
      columns: [
        {
          field: 'id', label: "Actions",
          sortable: false,
          thClass: "vgt-headers narrower",
        },
        {
          field: 'product_name', label: "Product",
          sortable: false,
          thClass: "vgt-headers",
        },
        {
          field: 'sku', label: "SKU",
          sortable: false,
          thClass: "vgt-headers",
        },
        {
          field: 'service_class', label: "Service Class",
          sortable: false,
          thClass: "vgt-headers narrow",
        },
        {
          field: 'package_type', label: "Package Type",
          sortable: false,
          thClass: "vgt-headers narrow",
        },
        {
          field: 'weight_lb', label: "Weight (lb.)",
          sortable: false,
          thClass: "vgt-headers narrowest",
        },
        {
          field: 'weight_oz', label: "Weight (oz.)",
          sortable: false,
          thClass: "vgt-headers narrowest",
        },
        {
          field: 'package_length', label: "Package (L)",
          sortable: false,
          thClass: "vgt-headers narrowest",
        },
        {
          field: 'package_width', label: "Package (W)",
          sortable: false,
          thClass: "vgt-headers narrowest",
        },
        {
          field: 'package_height', label: "Package (H)",
          sortable: false,
          thClass: "vgt-headers narrowest",
        },
        // {
        //   field: 'packaging_weight', label: "Packaging Weight (oz.)",
        //   sortable: false,
        //   thClass:"vgt-headers narrowest",
        // },
        {
          field: 'declared_value', label: "Declared Value",
          sortable: false,
          thClass: "vgt-headers",
        },
      ],

      noLB: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      getCarrierRules: "getCarrierRules",
      shipping_services: "getShippingServices",
    }),
    isEmployeesInvalid() {
      let invalid = false;
      this.security.employees.forEach(e => {
        if (invalid) { return; }
        if (_.isEmpty(e.name) || this.checkUserName(e.username) || this.checkPassword(e.password)) {
          invalid = true;
        }
      });
      return invalid;
    },
    noWeight() {
      const { oz, lb } = this.product.weight;
      const isNull = [NaN, 0];
      if (isNull.includes(parseInt(oz)) && isNull.includes(parseInt(lb))) return true;
      return false;
    },
    isProductInvalid() {
      if (!this.product.product_name || !this.product.service_class || this.noWeight
        || !this.product.package_type || !this.checkDimensions) return true
      return false
    },
    carrierRules: function () {
      return this.getCarrierRules(this.country || 'US');
    },
    serviceOptions() {
      try {
        let options = Object.keys(this.carrierRules).map(serviceId => {
          return _.find(this.shipping_services, s => {
            return s && s.code === serviceId;
          });
        });

        options = _.orderBy(options, "order");

        options = options.map(option => {
          let packageOptions = this.getPackageOptions(option.code);

          // Make sure at least 1 option exists
          if (!packageOptions.length) {
            return null;
          }

          return {
            value: option.code,
            text: option.name
          };
        });
        return _.filter(options);
      } catch (e) {
        // console.error(e);
        return [];
      }
    },
    packageOptions() {
      if (_.isEmpty(this.product.service_class)) {
        this.product.package_type = '';
        return [];
      }

      let options = this.getPackageOptions(this.product.service_class);
      console.log('options', options);

      return options;
    },
    checkDimensions() {
      const length = this.product.package_length;
      const width = this.product.package_width;
      const height = this.product.package_height;

      const hasAll = length && width && height;
      if (this.product.package_type === "SOFTPACK") {
        this.product.package_height = 1
        if (!hasAll) return false;
        return true;
      } else {
        const dim = [parseInt(height), parseInt(width), parseInt(length)];
        console.log(dim)
        const hasNull = dim.some(d => isNaN(d) || d < 1)
        const hasVal = dim.some(d => d > 0)

        console.log("hasNull", hasNull, "hasVal", hasVal)
        if (hasNull && hasVal) return false
        return true;
      }
    },
    isDimAllowed() {
      if (this.product.package_type) {
        if (["SOFTPACK", "PKG"].includes(this.product.package_type)) return false;
        this.product.package_length = null;
        this.product.package_height = null;
        this.product.package_width = null;
        return true;
      }
      return false;
    },
  },
  async created() {
    await this.fetchInfo()
  },
  async mounted() {
    this.isLoading = true;
    await this.fetchOrigins();
    const [response, emailTemplates] = await Promise.all([
      axios.get("/pb/merchant_signup_url"),
    ]);

    if (response.data.url) {
      this.signupUrl = response.data.url;
    }
    this.isLoading = false;
    // execute this after next event iteration
    await this.$nextTick();
    this.showIntegration = this.$route.query.integration;
    // this.security.new_name = this.user.name;
    // this.security.new_username = this.user.shipper_username.split("@gs")[0];
    // this.security.new_password = this.user.shipper_password;
    await this.getEmployees();
    // console.log("user", this.user);

    this.showProductTab = this.$route.query.product;
    // this.showGuaranteedClaim = this.$route.query.guaranteedClaim;
    if (this.showProductTab) {
      await this.fetchProducts();
    }
  },
  methods: {
    ...mapActions(["refreshUser"]),
    onTouch() {
      console.log('touched!')
      this.isSubUserDirty = true
    },
    async fetchInfo() {
      const [users, emailTemplates] = await Promise.all([
        axios.get("/users"),
        await this.loadEmailTemplates()
      ]);
      if (users.data.shipper_tabs) {
        this.security.tabs = users.data.shipper_tabs;
      }
      if (users.data.shipper_features) {
        this.security.features = users.data.shipper_features;
      }
      console.log('tabs', this.security.tabs);
    },
    async fetchOrigins() {
      const response = await axios.get("user/addresses");
      if (response.data.length > 0) {
        const shipperAddr = response.data.map(or => {
          let full_name = `${or.first_name || ''} ${or.last_name || ''}`;
          if (full_name.trim() && or.company) full_name = `${full_name}, ${or.company}`;
          else if (!full_name.trim()) full_name = or.company;
          return {
            value: or,
            text: `${full_name}, ${or.address}, ${or.city}, ${or.state}`
          }
        });

        this.shipper_addresses = _.concat({
          value: '',
          text: 'Please Select an Origin Address'
        }, shipperAddr);

        console.log('shipper_addresses', this.shipper_addresses)
      }
    },
    onClickConnectPitneyBowes() {
      const requestData = {
        username: this.connectForm.username,
        password: this.connectForm.password
      };

      this.isLoading = true;

      axios
        .post("/pb/connect", requestData)
        .then(response => {
          const shipperId = response.data.shipper_id;
          const paymentId = response.data.payment_id;

          axios
            .post("/user/pb_ids", {
              shipper_id: shipperId,
              payment_id: paymentId
            })
            .then(updateResponse => {
              this.$emit("alert", {
                message: "Pitney Bowes integrated!",
                type: "success"
              });
              this.refreshUser();
            })
            .finally(() => {
              this.isLoading = false;
            });
        })
        .catch(() => {
          this.$emit("alert", {
            message: "Invalid Pitney Bowes credentials.",
            type: "danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    checkUserName(uname) {
      const chck_dup = this.security.employees.filter(e => e.username === uname);
      return (chck_dup.length > 1 || (uname && uname.length < 4) || withSpace(uname) || _.isEmpty(uname))
    },
    checkPassword(pword) {
      return (!isPasswordSecure(pword) || _.isEmpty(pword))
    },
    async updateSecurity() {
      let invalid_data = false;

      this.security.employees.forEach(e => {
        if (invalid_data) { return; }
        // const chck_dup = this.security.employees.filter(obj => obj.username === e.username);
        // if (chck_dup.length > 1) {
        //   invalid_data = true;
        //   // this.$emit("alert", {
        //   //   message: "The username must be unique",
        //   //   type: "danger"
        //   // });
        // }
        if (_.isEmpty(e.name)) {
          invalid_data = true;
          // this.$emit("alert", {
          //   message: "Name is invalid",
          //   type: "danger"
          // });
        }
        if (this.checkUserName(e.username)) {
          invalid_data = true;
          // this.$emit("alert", {
          //   message: "Username is invalid",
          //   type: "danger"
          // });
        }
        if (this.checkPassword(e.password)) {
          invalid_data = true;
          // this.$emit("alert", {
          //   message: "Password is invalid",
          //   type: "danger"
          // });
        }
      });

      try {
        if (!invalid_data) {
          const response = await axios.post("/users/security", this.security);
          this.$emit("alert", {
            message: response.data.message,
            type: "success"
          });
        } else {
          this.$emit("alert", {
            message: "Data provided for shippers is invalid",
            type: "danger"
          });
        }
      } catch (e) {
        this.$emit("alert", {
          message: e.response.data.message,
          type: "danger"
        });
      } finally {
        this.isSubUserDirty = false
        await this.fetchInfo();
        await this.refreshUser();
        await this.getEmployees();
      }
    },
    // email notifier
    async setParam(param) {
      const el = this.$refs.emailBody.$el;
      const val = `[[${param}]]`;
      // https://jsfiddle.net/Znarkus/Z99mK/
      if (el.selectionStart || el.selectionStart == '0') {
        var startPos = el.selectionStart;
        var endPos = el.selectionEnd;
        el.value = el.value.substring(0, startPos)
          + val
          + el.value.substring(endPos, el.value.length);
        el.selectionStart = startPos + val.length;
        el.selectionEnd = startPos + val.length;
      } else {
        el.value += val;
      }
      console.log("el value: ", el.value);
      this.emailTemplate.body = el.value;
      console.log("template value: ", this.emailTemplate.body)
    },
    async loadEmailTemplates() {
      const emailTemplates = await axios.get('/email-templates');
      const { data: { res } } = emailTemplates;
      console.log('email templates: ', res);
      this.emailTemplates = res;
      this.emailTemplateOptions = res.map(v => {
        return {
          text: v.name,
          value: v.id
        }
      });
      const defaulTemplate = res.find(v => !!v.active);
      if (defaulTemplate) {
        this.defaultTemplate = true;
        this.selectedEmailTemplate = defaulTemplate.id;
        this.emailTemplate = Object.assign({}, defaulTemplate);
      }
    },
    async setDefaultTemplate(val) {
      if (!this.user.subscribed) {
        await this.promptToSubscribe();
        return;
      }
      if (val) {
        await axios.patch(`/email-templates/${this.selectedEmailTemplate}`, {
          active: 1
        });
        await this.loadEmailTemplates();
      }
    },
    async emailToggle(val) {
      const { value } = val;
      if (!this.user.subscribed) {
        await this.promptToSubscribe();
        return;
      }
      try {
        const response = await axios.post('/user-email-notif', { emailToggle: value });
        console.log(response);
        this.$emit("alert", {
          message: `Email Notification is ${value ? 'enabled' : 'disabled'}!`,
          type: value ? 'success' : 'danger',
        });
        this.refreshUser();
      } catch (e) {
        console.log(e);
        this.$emit("alert", {
          message: "Unable to save update!",
          type: "danger"
        });
      }
    },
    async saveEmailTemplate() {
      try {
        const { id } = this.emailTemplate;
        console.log("email template: ", this.emailTemplate);
        // update else create
        if (id) {
          await axios.patch(`/email-templates/${id}`, this.emailTemplate);
        } else {
          await axios.post('/email-templates', this.emailTemplate);
        }
        this.$emit("alert", {
          message: `Template ${this.emailTemplate.name} has been saved successfully!`,
          type: "success"
        });
        await this.loadEmailTemplates();
      } catch (e) {
        console.error(e);
        this.$emit("alert", {
          message: "Unable to save template!",
          type: "danger"
        });
      }
    },
    async showTheTemplate() {
      this.emailTemplate = this.emailTemplates.find(v => v.id == this.selectedEmailTemplate);
      if (this.emailTemplate.active) {
        this.defaultTemplate = true;
      } else {
        this.defaultTemplate = false;
      }
    },
    checkFormValidity() {
      const valid = this.$refs.emailTest.checkValidity()
      this.emailState = valid
      return valid
    },
    async okTestEmail(e) {
      e.preventDefault()
      await this.sendTestEmail()
    },
    async sendTestEmail() {
      if (!this.checkFormValidity()) {
        return
      }
      try {
        const formData = Object.assign({}, this.emailTemplate, { receipient: this.testEmail })
        const response = await axios.post('test-email-notifier', formData);
        const { data: { status, res } } = response;
        this.$emit("alert", {
          message: res,
          type: "success"
        });
      } catch (e) {
        console.error(e);
        this.$emit("alert", {
          message: "Unable to send test email!",
          type: "danger"
        });
      } finally {
        this.$nextTick(() => {
          this.$bvModal.hide('test-email-modal')
        })
      }
    },
    async clearEmailTemplateFields() {
      this.emailTemplate = {
        name: '',
        fromEmail: '',
        fromName: '',
        subject: '',
        body: `
Hello [[RECIPIENT_FULL_NAME]],

You've got a USPS package heading your way!

Shipped on: [[SHIPMENT_DATE]]

Estimated Delivery Date: [[ESTIMATED_DELIVERY_DATE]]

Recipient Address: [[RECIPIENT_ADDRESS]]

Service Class: [[SERVICE_CLASS]]

Shipped via USPS: [[TRACKING_NUMBER_LINK]]

Please allow up to 24 hours for tracking events to update.

Regards,

[[SENDER_FULL_NAME]]`.trim(),
      }
    },
    async promptToSubscribe() {
      // const msg = `Please subscribe to enable supreme features.`;
      // let dialog = null;
      // try {
      //   dialog = await this.$dialog.confirm(msg);
      console.log('needs to subscribe first');
      this.$router.push({ path: '/my-account/subscription' });
      return;
      // } catch (e){
      //   console.log(e);
      // }finally{
      //   dialog.close();
      // }
    },
    async getEmployees() {
      if (this.user.employees.length > 0) {
        this.security.employees = this.user.employees.map(e => {
          const origin = this.shipper_addresses.find(obj => obj.value.id === e.origin_id)
          return {
            id: e.id,
            name: e.name,
            username: e.username.split('@gs')[0],
            password: e.password,
            origin_id: e.origin_id,
            selectedOrigin: origin ? origin.value : '',
          }
        });
      }
      this.isSubUserDirty = false
    },
    addNewUser() {
      this.security.employees.push({});
    },
    async saveUser(username, id = null) {
      let data = (id) ? this.security.employees.find(obj => obj.id === id) : this.security.employees.filter(obj => obj.username === username);

      // check duplicates
      console.log('data', data);
      if (data.length > 1) {
        this.$emit("alert", {
          message: "The username has already been taken",
          type: "danger"
        });
        return;
      }

      if (Array.isArray(data)) { data = data[0] }

      // check username
      console.log("username: ", data.username.length < 4, withSpace(data.username))
      if (data.username.length < 4 || withSpace(data.username)) {
        this.$emit("alert", {
          message: "The username is invalid",
          type: "danger"
        });
        return;
      }

      // check password
      console.log("password: ", !isPasswordSecure(data.password))
      if (!isPasswordSecure(data.password)) {
        this.$emit("alert", {
          message: "The password is invalid",
          type: "danger"
        });
        return;
      }

      // data.username = `${data.username}@gs${this.user.id}.com`;
      const url = (data.id) ? '/employee/update' : '/employee';

      try {
        const response = await axios.post(url, data);

        if (response.data.status === 'error') {
          response.data.errors.forEach(data => {
            this.$emit("alert", {
              message: data,
              type: "danger"
            });
          })
        } else {
          this.$emit("alert", {
            message: response.data.message,
            type: "success"
          });
        }
      } catch (e) {
        console.log('error saving', e.response);
        this.$emit('alert', {
          message: e.response.data.message,
          type: 'danger'
        });
      } finally {
        await this.fetchInfo();
        await this.refreshUser();
        await this.getEmployees();
      }
    },
    async deleteUser(id) {
      try {
        let dialog = await this.$dialog.confirm({ title: "Delete Sub-User", body: "Are you sure you want to delete this sub-user?" }, {
          view: 'warning',
          customClass: 'warning-dialog',
        });
        dialog.close();
      } catch (e) {
        return;
      }

      this.security.employees = this.security.employees.filter(obj => obj.id !== id);
      if (id) {
        console.log('deleting employee', id);
        axios
          .post('/employee/delete', { id: id })
          .then(r => {
            console.log('employee deleted', r);
            this.$emit('alert', {
              message: r.data.message,
              type: 'success'
            });
          })
          .catch(e => {
            this.$emit('alert', {
              message: e.response.data.message,
              type: 'danger'
            });
          });
      }
      await this.fetchInfo();
      await this.refreshUser();
      await this.getEmployees();
    },

    // VGT EVENTS
    updateVGTParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onVGTSelected(params) {
      if (params.selectedRows.length > 0) {
        const ids = params.selectedRows.map(v => v.id);
        this.updateVGTParams({ ids });
        this.selected = ids;
      } else {
        this.updateVGTParams({ ids: [] });
        this.selected = [];
      }
    },
    onVGTSearch(params) {
      this.updateVGTParams({ searchTerm: params.searchTerm });
      this.fetchProducts();
    },
    onVGTPageChange(params) {
      this.updateVGTParams({ page: params.currentPage });
      this.fetchProducts();
    },
    onVGTPerPageChange(params) {
      this.updateVGTParams({ perPage: params.currentPerPage });
      this.fetchProducts();
    },
    onVGTSortChange(params) {
      if (!params.length) return
      const { field, type } = params[0];
      this.updateVGTParams({ sort: [field, type] });
      this.fetchProducts();
    },
    onVGTColumnFilter(params) {
      this.updateVGTParams(params);
      this.fetchProducts();
    },
    onVGTColumnSelect() {
      this.columns = this.columns.map(column => {
        if (column.field !== 'id') {
          column.hidden = this.selectedColumns.includes(column.field) ? false : true;
        }
        return column;
      })
      this.updateVGTParams({ columns: this.selectedColumns });
      const cols = Object.assign({}, { columns: this.columns, selectedColumns: this.selectedColumns });
      lStore.set(`productColumns`, cols);
    },

    async onShowProductModal() {
      this.showProductModal = true;
    },

    async onHideProductModal(save = false) {
      try {
        this.showProductModal = false;
        if (save) {
          // add product
          this.product.total_weight = parseFloat(this.product.weight.lb || 0) * 16 + parseFloat(this.product.weight.oz || 0);

          let url = 'products'
          let method = 'post'
          if (this.isProductEdit) {
            url += `/${this.product.id}`
            method = 'patch'
            this.isProductEdit = false;
          }
          await axios({ method: method, url: url, data: this.product })
          await this.fetchProducts();
        }
      } catch (e) {
        console.log('error closing product modal', e);
      } finally {
        this.clearProduct();
        this.noLB = false;
        this.isProductEdit = false;
      }
    },

    clearProduct() {
      this.product = {
        id: '',
        product_name: '',
        sku: '',
        service_class: '',
        package_type: '',
        package_length: '',
        package_width: '',
        package_height: '',
        // packaging_weight: '',
        declared_value: '',
        total_weight: 0,
        weight: {
          lb: '',
          oz: ''
        }
      }
    },

    async fetchProducts() {
      try {
        this.isLoading = true;
        const response = await axios.get('products', { params: this.serverParams });
        const { data: { data, total } } = response;
        this.totalRecords = total;
        this.rows = data;
      } catch (e) {
        console.log('error fetching products', e);
      } finally {
        this.isLoading = false;
      }
    },

    async imported() {
      console.log('imported done');
      await Promise.all([
        this.fetchProducts(),
      ]);
    },

    async showProduct(id) {
      try {
        this.isLoading = true;

        const { data } = await axios.get('/products/' + id);
        this.product = data;
        this.product.package_length = parseFloat(data.package_length) || ''
        this.product.package_width = parseFloat(data.package_width) || ''
        this.product.package_height = parseFloat(data.package_height) || ''
        this.product.declared_value = parseFloat(data.declared_value) || ''
        this.product.weight = this.getWeight(data.weight)

        if (this.product.service_class == "FCM") {
          this.noLB = true;
          this.product.weight.lb = '';
        }

        this.isProductEdit = true;
        this.showProductModal = true;
      } catch (e) {
        console.log('error getting product data', e);
      } finally {
        this.isLoading = false;
      }
    },

    async deleteProducts() {
      const ids = this.serverParams.ids;
      console.log('deleting', ids);

      try {
        const msg = `You are attempting to delete ${ids.length} records.&nbsp;&nbsp;This action is irreversible.`;
        let dialog = await this.$dialog.confirm(msg, {
          view: 'warning',
          customClass: 'warning-dialog',
        });
        dialog.close();
      } catch (e) {
        return;
      }

      this.isLoading = true;
      try {
        const response = await axios.delete('products', { data: { products: ids } });
        console.log('delete response', response);
        await this.fetchProducts();
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
        this.serverParams.ids = [];
      }
    },

    getWeight(weight) {
      const lb = Math.floor(weight / 16);
      const oz = Math.round(weight % 16);
      return {
        lb: lb + (oz > 15 ? 1 : 0),
        oz: (oz > 15) ? 0 : oz
      };
    },

    getPackageOptions(serviceId) {
      // console.log("SERVICE ID", serviceId);
      let rules = this.$store.getters.getServicePackageRules(
        serviceId,
        this.country || 'US',
        true // filter inactive mail classes
      );

      // Flat Rates, this needs to be updated annually
      const flatRates = {
        EM: {
          FRE: "$24.90",
          LGLFRENV: "$25.15",
          PFRENV: "$25.35"
        },
        PM: {
          FRE: "$7.60", // Flat Rate Envelope
          SFRB: "$8.10", // Small Flat Rate Box
          LFRB: "$18.95", // Large Flat Rate Box
          LGLFRENV: "$7.90", // Legal Flat Rate Envelope
          FRB: "$14.00", // Medium Flat Rate Box
          MLFRB: "$18.35", // APO/FPO/DPO
          PFRENV: "$8.30" // Padded Flat Rate Envelope
        }
      }

      let options = serviceId
        ? rules.map(rule => {
          let name = rule.brandedName;

          if (
            serviceId in flatRates &&
            rule.parcelType in flatRates[serviceId]
          ) {
            name += " - " + flatRates[serviceId][rule.parcelType];
          }

          return {
            value: rule.parcelType,
            text: name
          };
        })
        : [];

      return _.orderBy(options, "text");
    },

    onServiceClassChange(val) {
      this.product.service_class = val;
      this.product.package_type = 'PKG';

      switch (val) {
        case "FCM":
          this.noLB = true;
          this.product.weight.lb = '';
          break;
        default:
          this.noLB = false;
      }
      // if(this.dim_set || this.weight_set){
      //   this.dw_set = true;
      // }
    },

    // showServiceOptions(){
    //   const options = this.serviceOptions;
    //   console.log('getting service options', options);
    //   return options;
    // },

    async onPackageChange() {
      const { lb, oz } = this.product.weight;

      // if no weight, do nothing
      if (lb === null || oz === null) return;
      if (lb === 0 && oz === 0) return;

      // if(this.dim_set || this.weight_set){
      //   this.dw_set = true;
      // }
    },

    // async onChangeDimensions() {
    //   console.log('onDimension changed called');
    //   const status = this.checkDimensions;
    //   if(status !== false && (this.product.weight.lb || this.product.weight.oz )){
    //     await this.$nextTick();
    //     if(this.dim_set){
    //       console.log("set dw_set to true via weight change")
    //       this.dw_set = true;
    //     }
    //     console.log("dw_set value via dimension", this.dw_set);
    //     this.dim_set = true;
    //   }
    // },
    // async guarnateedClaimToggle(val){
    //   const {value} = val;
    //   if(!this.user.subscribed){
    //     await this.promptToSubscribe();
    //     return;
    //   }
    //   try{
    //     const response = await axios.post('/user-guaranteed-claim', {guaranteed_claim: value});
    //     console.log(response);
    //     this.$emit("alert", {
    //       message: `Guaranteed Claim is ${value? 'enabled' : 'disabled'}!`,
    //       type: value? 'success' : 'danger',
    //     });
    //     this.refreshUser();
    //   } catch (e) {
    //     console.log(e);
    //     this.$emit("alert", {
    //       message: "Unable to save update!",
    //       type: "danger"
    //     });
    //   }
    // },
    changeEmployeeOrigin(origin, employee) {
      if (origin) {
        this.isSubUserDirty = true
        const indx = this.security.employees.findIndex((obj => obj.id == employee.id));
        this.security.employees[indx] = Object.assign({}, employee, {
          origin_id: origin.value ? origin.value.id : origin.id,
          selectedOrigin: origin.value ? origin.value : origin,
        })
        // console.log(this.security.employees[indx])
      }
    },
    changeSecurityTabs(value, tab) {
      if (value) {
        this.security.tabs = _.concat(this.security.tabs, tab);
      } else {
        this.security.tabs = _.without(this.security.tabs, tab)
      }
      // console.log(value, this.security.tabs);
    },
    async saveSecurityTabs() {
      try {
        const response = await axios.post("/users/security-tabs", this.security);
        this.$emit("alert", {
          message: response.data.message,
          type: "success"
        });
      } catch (e) {
        this.$emit("alert", {
          message: e.response.data.message,
          type: "danger"
        });
      } finally {
        await this.fetchInfo();
        await this.refreshUser();
        await this.getEmployees();
      }
    },
    customSelectedRows() {
      if (this.customRange) {
        for (let i = 0; i < this.rows.length; i++) {
          this.$set(this.rows[i], 'vgtSelected', false);
        }

        const subtractTo = (this.serverParams.page - 1) * this.serverParams.perPage;
        let parseRange = [], start, end;

        this.customRange.split(',').forEach(i => {
          if (i.indexOf('-') > 0) {
            [start, end] = i.split('-').map(Number)
            if (start <= this.totalRecords && start < end) {
              if (end > this.totalRecords) {
                end = (this.serverParams.page || 1) * this.serverParams.perPage
              }
              _.range(start, end + 1).forEach(i => {
                i = subtractTo > 0 ? i - subtractTo : i
                parseRange.push(i)
              });
            }
          } else {
            i = parseInt(i);
            if (i <= this.totalRecords) {
              i = subtractTo > 0 ? i - subtractTo : i
              parseRange.push(i)
            }
          }
        })
        _.uniq(parseRange).forEach(i => {
          if (this.rows[i - 1]) {
            this.$set(this.rows[i - 1], 'vgtSelected', true);
          }
        })
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/SupremeFeatures.vue